import React from 'react';
import './ServiceSubTitle.less';

function ServiceSubTitle({children}) {
  return (
    <h2 className='ServiceSubTitle'>
      {children}
    </h2>
  );
}

export default ServiceSubTitle;


// WEBPACK FOOTER //
// ./src/routes/Service/ServiceSubTitle.js